import React from "react";
import { motion } from "framer-motion";
import { fadeInUp } from "../motion";
import { Heading } from "./Heading";

/**
 * PageHeader — editorial page hero used at the top of every portal page.
 * Optional eyebrow (mono uppercase), title (serif display), lede (refined sans),
 * and a trailing actions slot.
 */
export function PageHeader({
  eyebrow,
  title,
  lede,
  actions,
  className = "",
  align = "left",
}) {
  const alignCls = align === "center" ? "text-center items-center" : "";
  return (
    <motion.header
      variants={fadeInUp}
      initial="initial"
      animate="animate"
      className={`flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between ${className}`}
    >
      <div className={`flex flex-col gap-3 max-w-2xl ${alignCls}`}>
        {eyebrow && (
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--foreground-muted))]">
            {eyebrow}
          </p>
        )}
        <Heading level="display" className="!text-[40px] sm:!text-[52px] lg:!text-[60px]">
          {title}
        </Heading>
        {lede && (
          <p className="font-accent italic text-lg sm:text-xl text-[hsl(var(--foreground-secondary))] leading-relaxed max-w-xl">
            {lede}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 sm:pb-2">{actions}</div>
      )}
    </motion.header>
  );
}
